import { createAction } from '@reduxjs/toolkit';
import { ADD_MESSAGE, REMOVE_MESSAGE } from './constants';

export const addMessage = createAction(ADD_MESSAGE);
export const removeMessage = createAction(REMOVE_MESSAGE);
